import React from "react";
import { useTranslation } from "react-i18next";
import TwoFactorAuth from "../components/TwoFactorAuth";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TwoFactorAuthPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleTwoFASuccess = () => {
    // Navigate back to dashboard after successful 2FA setup
    // Add a small delay to ensure the backend has updated
    setTimeout(() => {
      navigate("/New-Dashboard");
      // Force a page reload to update 2FA status
      window.location.reload();
    }, 1000);
  };

  return (
    <div className="min-h-screen  py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 mb-4 md:mb-6 text-sm md:text-base font-semibold text-gray-700 hover:text-gray-900 transition-colors bg-white border border-gray-200 rounded-xl px-3 md:px-4 py-2 shadow-sm"
          >
            <ArrowLeft className="w-4 h-4 md:w-5 md:h-5" />
            <span>{t("twoFactorAuthPage.back")}</span>
          </button>
          {/* <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-600 hover:text-gray-800 mb-4"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </button> */}
          <h1 className="text-3xl font-bold text-gray-900">
            {t("twoFactorAuthPage.title")}
          </h1>
          <p className="text-gray-600 mt-2">
            {t("twoFactorAuthPage.subtitle")}
          </p>
        </div>

        {/* 2FA Component */}
        <div className="bg-white rounded-[25px] shadow-sm border border-gray-200 p-6">
          <TwoFactorAuth
            isOpen={true}
            onClose={() => navigate(-1)}
            standalone={true}
            onSuccess={handleTwoFASuccess}
          />
        </div>
      </div>
    </div>
  );
};

export default TwoFactorAuthPage;
